module.exports = __webpack_public_path__ + "1e4c40c4476a89d80899d42293085a39.png";